import { useCallback } from "react";
import { useNavigate as useRouterNavigate } from "react-router-dom";

// Remember Ctrl/Cmd clicks so programmatic navigation can open a new tab instead.
let modClickAt = 0;
if (typeof document !== "undefined") {
  document.addEventListener("click", (e) => { modClickAt = e.ctrlKey || e.metaKey ? Date.now() : 0; }, true);
}

export function useNavigate() {
  const navigate = useRouterNavigate();
  return useCallback((to, opts) => {
    if (typeof to === "string" && modClickAt && Date.now() - modClickAt < 1500) {
      modClickAt = 0;
      window.open(to, "_blank", "noopener");
      return;
    }
    navigate(to, opts);
  }, [navigate]);
}
